module.exports = __webpack_public_path__ + "img/hero-lg.e207cf9c.png";